import React from 'react';
import { gql } from '@apollo/client';
import { BooleanField, Show, SimpleShowLayout, TextField } from 'react-admin';
import TimestampFields from 'components/TimestampFields';

const PositionSpecialtiesShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <TextField label="Position ID" source="position.id" />
      <TextField label="Position" source="position.display_name" />
      <TextField label="Specialty ID" source="specialty.id" />
      <TextField label="Specialty" source="specialty.label" />
      <BooleanField source="high_risk" />
      <TimestampFields />
    </SimpleShowLayout>
  </Show>
);

PositionSpecialtiesShow.query = gql`
  query GET_ONE($id: Int!) {
    positionSpecialty(id: $id) {
      id
      high_risk
      position {
        id
        display_name
      }
      specialty {
        id
        name
        label
      }
      created_at
      updated_at
    }
  }
`;

export default PositionSpecialtiesShow;
